import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH } from "../Config/Config";

const fetchDevices = async (platform) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(`
        ${API_BASE_PATH}/KeyLogging/active/${platform}`);

  return response.data;
};

const useGetAvailableDevices = (platform, options = {}) => {
  return useQuery({
    queryFn: () => fetchDevices(platform),
    queryKey: ["fetchDevices", platform],
    enabled: options.enabled,
    ...options,
  });
};

export default useGetAvailableDevices;